import { useEffect, useState } from 'react';
import { useLocalStorage } from 'core/hooks/useLocalStorage';
import Immutable from 'immutable';
import * as API from '../../../api';
import { QUESTION_GROKKED } from 'edrolo/domains/exams';

export const useDemoQuestionResponse = (sittingId, questionId) => {
  const [examResponse, setExamResponse] = useLocalStorage(
    `examQuestionResponse-${questionId}`,
    null,
    !!'isImmutable'
  );

  const [loading, setLoading] = useState(false);

  /*
   * If a response does exist, attempt to mark it as "completed".
   * This would otherwise be done via the `completed` property on the ExamResponse
   * model, but is done here because the demo experience bypasses the backend after
   * the initial response is created. The completed state of a response is used to
   * toggle the disabled state of the "next question" button, so if it is not set
   * correctly, the user will be blocked from navigating to the next question.
   */
  useEffect(() => {
    if (examResponse) {
      const isResponseComplete =
        examResponse.get('grokked') !== QUESTION_GROKKED.NO_RESPONSE;
      const updatedResponse = examResponse.set('completed', isResponseComplete);
      setExamResponse(updatedResponse);
    }
  }, [examResponse, setExamResponse]);

  const submitQuestionResponse = async (
    examId,
    questionId,
    sittingId,
    typeSpecificData
  ) => {
    setLoading(true);
    const examResponse = await API.submitQuestionResponse(
      questionId,
      sittingId,
      typeSpecificData,
      !!'isDemo'
    );
    if (examResponse.ok) {
      setExamResponse(Immutable.fromJS(examResponse.body));
    }
    setLoading(false);
  };

  const submitChecklistReflectionItem = async (
    questionId,
    sittingId,
    checklistReflectionItem
  ) => {
    const { checked, exemplar_response_checklist_item: checklistItemId } =
      checklistReflectionItem;

    const updatedRepsonse = examResponse.update(
      'checklist_reflections',
      (checklistReflections) => {
        const indexForUpdate = checklistReflections.findIndex(
          (item) =>
            item.get('exemplar_response_checklist_item') == checklistItemId
        );

        if (indexForUpdate > -1) {
          return checklistReflections.setIn(
            [indexForUpdate, 'checked'],
            checked
          );
        } else {
          return checklistReflections.push(
            Immutable.fromJS({
              exemplar_response_checklist_item: checklistItemId,
              checked,
            })
          );
        }
      }
    );

    setExamResponse(updatedRepsonse);
  };

  const submitGrok = async (examId, questionId, sittingId, grokked) => {
    const updatedRepsonse = examResponse.set('grokked', grokked);
    setExamResponse(updatedRepsonse);
  };

  const submitMark = async (questionId, sittingId, mark) => {
    const updatedRepsonse = examResponse.set('text_marks_from_student', mark);
    setExamResponse(updatedRepsonse);
  };

  return {
    data: examResponse,
    loading,
    error: null,
    submitQuestionResponse,
    submitChecklistReflectionItem,
    submitGrok,
    submitMark,
  };
};
